Vue.component('exclusiveCards', {
  template: templates.exclusiveCards,
  data() {
    return {
      model: {
        edit: false,
        card: {
          name: null,
          hp: 0,
          attack: 0,
          defence: 0,
          accuracy: 0,
          speed: 0,
          type: null,
          ability: null,
          tier: 1,
          exclusiveUntil: null,
          active: false,
          image: null
        },
        cards: {},
        types: {},
        abilities: {},
        traits: [],
        tiers: {
          '1': {
            name: 'Standard'
          },
          '2': {
            name: 'Ultra'
          },
          '3': {
            name: 'Legendary'
          },
          '4': {
            name: 'Ultimate'
          }
        }
      }
    }
  },
  watch: {
    'model.card.image': function(newImage) {
      this.refreshImage();
    }
  },
  mounted() {
    const c = this;
    c.get();

    c.$root.$on('remove-existing-image', data => {
      c.removeCurrentFile(data);
    })
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      exclusiveCardService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = [`${d.id}.png`];
            data[`${d.id}`] = d;
          }
          c.model.cards = data;
          c.getTypes();
          c.getAbilities();
          c.getTraits();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTypes() {
      const c = this;
      let data = {};

      typeService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.types = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAbilities() {
      const c = this;
      let data = {};

      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.abilities = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTraits() {
      const c = this;

      traitService.get()
        .then(function (response) {
          c.model.traits = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.cards[`${id}`];

      if (id == c.model.card.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.card = {
        id: id,
        name: data.name,
        hp: data.hp,
        attack: data.attack,
        defence: data.defence,
        accuracy: data.accuracy,
        speed: data.speed,
        type: data.type,
        ability: data.ability,
        tier: data.tier,
        exclusiveUntil: data.exclusiveUntil,
        active: data.active,
        image: data.image
      };
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;
      const data = c.model.card;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (data.active && (data.hp == 0 || data.attack == 0 || data.defence == 0 || data.speed == 0)) {
        utils.alert.error('All stats are required to activate a card.');
        return;
      }

      exclusiveCardService.save(data)
        .then(function (response) {
          if (data.id) {
            c.model.cards[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.cards[`${data.id}`] = data;
          }
          c.reset();
          utils.alert.success('Saved!');
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    toggle(id) {
      const c = this;
      let card = c.model.cards[`${id}`];
      card.active = !card.active;

      exclusiveCardService.toggleActive({
        id: id,
        active: card.active ? 1 : 0
      })
        .then(function (response) {
          utils.alert.success('Updated!');
        })
        .catch(function (error) {
          utils.alert.error('Failed to update.');
        });
    },
    delete(id) {
      if (!confirm('Are you sure you want to delete this card?')) {
        return;
      }

      const c = this;
      let card = c.model.cards[`${id}`];
      card.deleted = true;

      exclusiveCardService.save(card)
        .then(function (response) {
          delete c.model.cards[`${id}`];
          utils.alert.success('Deleted!');
        })
        .catch(function (error) {
          utils.alert.error('Failed to delete.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      c.model.card = {
        name: null,
        hp: 0,
        attack: 0,
        defence: 0,
        accuracy: 0,
        speed: 0,
        type: null,
        ability: null,
        tier: 1,
        exclusiveUntil: null,
        active: false,
        image: null
      };
    },
    getCardUrl() {
      const c = this;
      const url = `${root}/images/exclusive-cards/`;
      return url;
    },
    removeCurrentFile(data) {
      const c = this;
      c.model.card.image = null;
    },
    refreshImage() {
      const c = this;
      c.$forceUpdate();
    },
    handleCardImageUpload(data) {
      const c = this;

      if (data && data.files && data.files.length > 0) {
        // Update the card image with the uploaded file name
        c.model.card.image = [`${c.model.card.id}.png`];
        utils.alert.success('Image uploaded!');
        c.refreshImage();
      }
    }
  },
});
